<template>
  <div
    id="integrationSetting"
    class="mx-5"
  >
    <div class="mt-2 d-flex justify-space-between">
      <div class="d-flex">
        <v-img
          contain
          :max-width="60"
          :src="require(`@/assets/conectiontab/retail-express.png`)"
          class="mx-3 mt-5"
        />
        <h2
          style="line-height:85px;"
          class="mr-3"
        >
          Retail Express
        </h2>
      </div>
      <v-col cols="1">
        <v-btn
          v-track="'close-rex-detail-drawer'"
          class="text-right mt-3"
          icon
          @click.stop="
            $store.commit('ui/drawer.right.toggle')
          "
        >
          <v-icon
            style="background-color:transparent"
            medium
          >
            mdi-close
          </v-icon>
        </v-btn>
      </v-col>
    </div>
    <div class="mx-3">
      <v-card
        outlined
        class="update-card mb-5"
      >
        <v-row class="px-3 pt-3">
          <v-col cols="1">
            <v-icon
              color="#3FD06F"
              class="mr-3"
              style="font-size:35px;"
            >
              mdi-checkbox-marked-circle
            </v-icon>
          </v-col>
          <v-col class="ml-1">
            <v-row><h2>Integration Added</h2> </v-row>
            <v-row class="mt-2 pr-2">
              <p>
                You just added the Retail Express integration.
                We are syncing the data right now and you should check back in a few minutes.
                As you continue to use Retail Express,
                We will automatically keep that data in sync with Maropost.
              </p>
            </v-row>
          </v-col>
        </v-row>
      </v-card>
      <div id="retail-express-intergration-details">
        <h2>Integration Info</h2>
        <v-sheet
          v-if="isLoading"
          class="pa-3"
        >
          <v-skeleton-loader
            class="mx-auto"
            type="article"
            :loading="isLoading"
          />
        </v-sheet>

        <div
          v-else
          class="mt-5 py-2 px-3 bg-grey"
        >
          <v-row class="py-2">
            <v-col
              cols="3"
              class="py-0 font-weight-light"
            >
              Shop URL
            </v-col>
            <v-col class="py-0">
              {{ storeData.organization_name }}
            </v-col>
          </v-row>
          <v-row class="py-2">
            <v-col cols="3" class="py-0 font-weight-light">
              Shop Name
            </v-col>
            <v-col class="py-0">
              {{ storeData.nick_name }}
            </v-col>
          </v-row>
          <v-row class="py-2">
            <v-col
              cols="3"
              class="py-0 font-weight-light"
            >
              API Key
            </v-col>
            <v-col class="py-0">
              {{ storeData.client_id }}
            </v-col>
          </v-row>
          <v-row class="py-2">
            <v-col
              cols="3"
              class="py-0 font-weight-light"
            >
              Maropost List
            </v-col>
            <v-col class="py-0">
              <span v-if="storeData && storeData.crm_lists != undefined">
                {{ storeData.crm_lists[0].list.name }}
              </span>
            </v-col>
          </v-row>
        </div>
      </div>

      <div class="my-5">
        <h2>REX Fields Mapping to Maropost Fields</h2>
        <v-simple-table
          outlined
          class="mt-5 field-table"
        >
          <thead class="bg-grey">
            <tr>
              <th class="text-left">
                Maropost Fields
              </th>
              <th class="text-left">
                Retail Express Fields
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(field, index) in mappingField"
              :key=" `order${index}`"
            >
              <td :class="{ 'bg-grey': field.rex == '' }">
                {{ field.maropost }}
              </td>
              <td :class="{ 'bg-grey': field.rex == '' }">
                {{ field.rex }}
              </td>
            </tr>
            <template
              v-for="(field) in Object.keys(fields)"
            >
              <tr
                v-for="(key, index) in Object.keys(fields[field])"
                :key="index"
              >
                <td>
                  {{ key }}
                </td>
                <td>
                  {{ fields[field][key] }}
                </td>
              </tr>
            </template>
          </tbody>
        </v-simple-table>
      </div>

      <v-btn
        v-track="'retail-express-store-index'"
        dark
        :to="'/accounts/' + $store.getters['auth/account'].id + '/integrations/retail_express'"
        class="mb-5"
        @click="navigateIndexPage()"
      >
        Done
      </v-btn>
    </div>
  </div>
</template>

<script>
  import { $integrations, $connectorApp } from '@/services'

  export default {
    name: 'RetailExpressDetailDrawer',
    data () {
      return {
        listDetails: { name: '' },
        isLoading: false,
        fields: {},
        storeData: {},
        mappingField:[
          {
            maropost: 'Product and Order items:',
            rex: '',
          },
          { maropost: "item_id",
            rex: "supplier_sku",
          },
          { maropost: "quantity",
            rex: "quantity_ordered",
          },
          { maropost: "price",
            rex: "order_item_total",
          },
          { maropost: "name",
            rex: "short_description",
          },
          { maropost: "store_url",
            rex: "",
          },
          { maropost: "product_price",
            rex: "sell_price_inc",
          },
          { maropost: "description",
            rex: "short_description",
          },
          { maropost: "product_category",
            rex: "product_type",
          },
          {
            maropost: 'Order:',
            rex: ''
          },
          { maropost: "grand_total",
            rex: "order_total",
          },
          { maropost: "original_order_id",
            rex: "order_number",
          },
          { maropost: "order_date",
            rex: "created_on",
          },
          { maropost: "order_status",
            rex: "status",
          },
          {
            maropost: 'Customer:',
            rex: '',
          },
          { maropost: "first_name",
            rex: "first_name",
          },
          { maropost: "last_name",
            rex: "last_name",
          },
          { maropost: "email",
            rex: "email",
          },
          { maropost: "status",
            rex: "marketing",
          },
          { maropost: "phone",
            rex: "phone",
          },
          { maropost: "fax",
            rex: "fax",
          },
          {
            maropost: 'Custom Fields:',
            rex: '',
          },
        ]
      }
    },
    mounted () {
      this.getStoreDetail(this.$store.getters['ui/drawer'].right.storeData)
      this.getFields()
    },
    beforeDestroy () {
      this.navigateIndexPage()
    },
    methods: {
      navigateIndexPage () {
        localStorage.removeItem('selected_integration_list_name')
        this.$router.push({
          name: 'Retail_express_index',
          query: { t: new Date().getTime() },
        })
      },
      getStoreDetail (data) {
        this.isLoading = true
        $integrations.getStoresList({ crm_type: 'retail_express', name: data.connection.name })
          .then(res => {
            this.storeData = res.data[0]
            let storeUrlField = this.mappingField.find(field => field.maropost == 'store_url')
            storeUrlField.rex = this.storeData.name
          })
          .finally(() => {
            this.isLoading = false
          })
      },
      getFields () {
        this.isLoading = true
        const connectionId = this.$store.getters['ui/drawer'].right.storeData.connection.id
        $connectorApp.getMappedFields('retail_express', connectionId)
          .then(res => {
            this.fields = res.data
          })
          .finally(() => {
            this.isLoading = false
          })
      },
    },
  }
</script>

<style scoped>
.bg-grey {
  background-color: #f4f4f4;
}
.update-card{
  border: 1px solid #3BCF6C !important;
}
.field-table{
  border: 1px solid rgba(0, 0, 0, 0.12);
}
</style>
